module.exports = __webpack_public_path__ + "images/news-banner.jpg";